export const ItemTypes = {
    PASSENGER: "passenger",
    VEHICLE: "vehicle"
  };